import React, { FC, useEffect, useState } from 'react';
import {
  AnswerContainer,
  Front,
  FrontContent,
  OptionalExplanationContainer,
  PreviewCardContainer,
  PreviewCardWrapper,
  QuestionContainer,
} from '../atoms/styles';
import { StudyCard } from 'src/modules/shared/slices/study-card/types/cards';
import FroalaEditorView from 'react-froala-wysiwyg/FroalaEditorView';
import { FontAwesomeSpriteButton } from 'src/modules/shared/components/FontAwesomeLocal';
import { SpriteIconsSolid } from 'src/config/api/models/FontAwesome';
import theme from 'src/config/theme';
import { useAppSelector } from 'src/modules/shared/hooks/useAppDispatch';
import { AccordionDetails, AccordionSummary } from '@material-ui/core';

type CardContentProps = {
  card: StudyCard;
  onClose: () => void;
};

const emptyContent = '<p><br></p>';

function checkExplanationContent(content?: string) {
  if (!content || content === emptyContent) return false;
  return true;
}
export const CardContent: FC<CardContentProps> = ({ card, onClose }) => {
  const opitionalExplanationHasContent: boolean = checkExplanationContent(card.optionalExplanation);
  const [expanded, setExpanded] = useState<boolean>(false);
  const currentPreviewCardIndex = useAppSelector(
    (state) => state.studyCard.currentPreviewCardIndex
  );

  useEffect(() => {
    setExpanded(false);
  }, [currentPreviewCardIndex]);

  return (
    <>
      <PreviewCardContainer>
        <PreviewCardWrapper>
          <Front>
            <FrontContent>
              <QuestionContainer>
                <FroalaEditorView model={card?.question} />
                <FontAwesomeSpriteButton
                  icon={SpriteIconsSolid.XMARK}
                  iconSize="1x"
                  color={theme.palette.common.black}
                  buttonStyle={{
                    backgroundColor: 'transparent',
                  }}
                  onClick={onClose}
                />
              </QuestionContainer>
              <AnswerContainer>
                <FroalaEditorView model={card?.answer} />
              </AnswerContainer>
              {opitionalExplanationHasContent && (
                <OptionalExplanationContainer
                  expanded={expanded}
                  onClick={() => setExpanded(!expanded)}
                >
                  <AccordionSummary aria-controls="panel1-content" id="panel1-header">
                    Toon meer
                  </AccordionSummary>
                  <AccordionDetails>
                    <FroalaEditorView model={card?.optionalExplanation} />
                  </AccordionDetails>
                </OptionalExplanationContainer>
              )}
            </FrontContent>
          </Front>
        </PreviewCardWrapper>
      </PreviewCardContainer>
    </>
  );
};
